import { Component } from '@angular/core';


export class SkyHelpInlineDemoComponent {
  public givingActionClick() {
    alert('Giving help inline clicked');
  }

  public emailActionClick() {
    alert('enter email in format joe@abc.com');
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-help-inline-demo',
  template: `<div>
  <h2>
    Giving
    <sky-help-inline
      (actionClick)="givingActionClick()">
    </sky-help-inline>
  </h2>

  <h4>
    Email entry
    <sky-help-inline
      (actionClick)="emailActionClick()">
    </sky-help-inline>
  </h4>

  <input placeholder="Enter email">
</div>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
